import {
  FlexiReimbursementCreateClaimResponse,
  FlexiReimbursementCreateClaimVariables,
  FlexiReimbursementEditClaimInput,
} from 'components/SalaryComponents/views/FlexibleBenefits/Claims/Create/types';
import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';

const editFlexiReimbursementClaimMutation = gql`
  mutation PayrollFlexiReimbursementEditClaim($input: FlexiReimbursementEditClaimInput!) {
    payrollFlexiReimbursementEditClaim(input: $input) {
      component_id
      component_display_name
      bill_amount
      description
      code
      success
      message
    }
  }
`;

export const editFlexiReimbursementClaim = (input: FlexiReimbursementEditClaimInput) => {
  return graphQLApi<FlexiReimbursementCreateClaimResponse, FlexiReimbursementCreateClaimVariables>({
    query: editFlexiReimbursementClaimMutation,
    queryVariables: { input },
  });
};
